import { Label } from 'components/ui/label';
import { Switch } from 'components/ui/switch';
import React, { useState } from 'react';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from 'components/ui/chart';
import { Bar, ResponsiveContainer } from 'recharts';
import { BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';
import { StyleGuide } from 'styles/StyleGuide';
import { ChartDataTemp } from './hooks/useLevelSensorData';
import { formatRoundedYAxisTick } from './chartFormatters';

export default function TempGraph({ tempData }: { tempData: ChartDataTemp[] }) {
  // const [showTotalUsage, setShowTotalUsage] = useState(false);

  const formatXAxis = (timestamp: string) => {
    const date = new Date(timestamp);
    return `${date.getDate()}/${date.getMonth() + 1} ${date.getHours()}:${date
      .getMinutes()
      .toString()
      .padStart(2, '0')}`;
  };

  const tempDisplay = tempData;

  const maxTempDisplay = 40;

  return (
    <div className="flex flex-wrap rounded-lg border bg-card p-6">
      <ChartContainer
        config={{
          temp: {
            label: '(°C)',
            color: StyleGuide.palette.amberDark, // Blue color for water
          },
        }}
        className="h-[300px] w-full"
      >
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={tempDisplay}
            margin={{ top: 10, right: 10, left: 10, bottom: 30 }}
            accessibilityLayer
            barSize={tempData.length > 100 ? 2 : tempData.length > 50 ? 5 : 10}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="timestamp"
              tickLine={false}
              axisLine={false}
              tickMargin={10}
              tickFormatter={formatXAxis}
              interval={Math.floor(tempData.length / 10)} // Show fewer ticks for readability
              angle={-45}
              textAnchor="end"
              height={60}
            />
            <YAxis
              tickLine={false}
              axisLine={false}
              tickMargin={10}
              allowDecimals={false}
              tickFormatter={formatRoundedYAxisTick}
              domain={[-20, maxTempDisplay]}
              label={{ value: 'Temperatur (°C)', angle: -90, position: 'insideLeft' }}
            />
            <ChartTooltip
              content={
                <ChartTooltipContent
                  labelFormatter={(_, data) => data[0]?.payload.formattedTime || ''}
                  formatter={(value, name) => {
                    if (name === 'temp') {
                      return [`${value} °C`];
                    }
                    return [value, name];
                  }}
                />
              }
            />
            <Bar dataKey="temp" fill={StyleGuide.palette.amber} radius={[4, 4, 0, 0]} name="temp" />
          </BarChart>
        </ResponsiveContainer>
      </ChartContainer>
    </div>
  );
}
